module.exports = __webpack_public_path__ + "static/img/3.ee19638.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/3.png
// module id = sAnz
// module chunks = 0